import styled from 'styled-components';

export const SectionNotFound = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    var(--highligth),
    var(--highligth) 50%,
    var(--color-gray) 50%,
    var(--color-gray)
  );
`;
